export const showButton = ({
  pageType,
  skpStatus,
  isAllowedByRBAC,
}: {
  pageType: string
  skpStatus: string
  isAllowedByRBAC: boolean
}) => {
  if (!isAllowedByRBAC) return false

  return (
    (pageType === 'sourcing' || pageType === 'internal') &&
    (skpStatus === 'Draft' || skpStatus === 'Rejected')
  )
}
